//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { GameStatus } from '../wheel.entity';

export const BetType = {
  INVENTORY: 'INVENTORY',
  BALANCE: 'BALANCE'
};

export default {
  name: 'WheelHomeBetCreatorNew',
  props: {
    game: {
      type: Object,
      default: null
    },
    userBets: {
      type: Array,
      default: () => []
    },
    betColor: {
      type: String,
      default: ''
    },
    isAuthenticated: {
      type: Boolean,
      default: false
    },
    betType: {
      type: String,
      default: BetType.BALANCE
    },
    betAmountUsd: {
      type: Number,
      default: 0
    },
    selectedInvItems: {
      type: Array,
      default: () => []
    },
    selectedInventoryAmountUsd: {
      type: Number,
      default: 0
    },
    selectedIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      GameStatus,
      BetType,
      isCreatingBet: false,
      MIN_BET_AMOUNT_USD: 0.25
    };
  },
  computed: {
    selectedAmountUsd() {
      return this.betType === BetType.INVENTORY
        ? this.selectedInventoryAmountUsd
        : this.betAmountUsd;
    },
    isButtonDisabled() {
      if (!this.game) {
        return true;
      }

      return (
        this.game.status === GameStatus.STARTED ||
        this.game.status === GameStatus.ENDED ||
        this.selectedAmountUsd <= 0 ||
        this.userBets.length >= 20
      );
    }
  },
  methods: {
    formatCurrency(val) {
      if (val === undefined || val === null) return '$0.00';
      return `$${Number(val).toFixed(2)}`;
    },
    createBet() {
      if (!this.isAuthenticated) {
        this.$emit('open-login');
        return;
      }

      if (this.betType === BetType.INVENTORY && this.selectedAmountUsd < this.MIN_BET_AMOUNT_USD) {
        this.$emit('notify-error', '下注金额低于最小值。最低下注金额为：0.25 Coin');
        return;
      }

      if (this.betType === BetType.BALANCE && this.betAmountUsd < this.MIN_BET_AMOUNT_USD) {
        this.$emit('notify-error', '下注金额低于最小值。最低下注金额为：0.25 Coin');
        return;
      }

      let inventoryItems = [];
      let betAmountUsd = 0;

      if (this.betType === BetType.BALANCE) {
        betAmountUsd = this.betAmountUsd;
      } else {
        inventoryItems = this.selectedIds;
      }

      this.isCreatingBet = true;

      this.$emit(
        'submit-bet',
        {
          color: this.betColor,
          type: this.betType,
          amount: betAmountUsd,
          items: inventoryItems
        },
        () => {
          this.isCreatingBet = false;
        }
      );
    }
  }
};
